export default {
    "clientes": [
        {
            "0": false,
            "ID": "1392166",
            "STATUS": "A",
            "NAME": "A&E ACABADOS EL VERGEL",
            "FEIN": "1792570727001",
            "CUSTOMER": "1376703931",
            "ADDRESS": "EL VERGEL VIA EL QUINCHE E1-488Y SAN PABLO - JUNTO AL COMPLEJO TURISTICO EL VERGEL",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "098 7000 498 / 02 239 3968",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "090-90 DAYS",
            "CREATION_DATE": "2019-02-25 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": "GLORIA NU?EZ",
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "090-90 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "enunez.arq@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392190",
            "STATUS": "A",
            "NAME": "AGUAS RODRIGUEZ ANA FERNANDA",
            "FEIN": "1713475752001",
            "CUSTOMER": "1483782124",
            "ADDRESS": "AV. SIMON BOLIVAR 386 Y SN - BARRIO SAN RAFAEL A 300 MTS DEL REDONDEL",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0992159663 / 2368139",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-02-20 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "disensass_guayllabamba@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392194",
            "STATUS": "A",
            "NAME": "AGUIRRE MEDIAVILLA SOR ELIZABET",
            "FEIN": "1711106318001",
            "CUSTOMER": "1519689584",
            "ADDRESS": "LIBORIO MADERA Y JUAN VALLAURI",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0968454029",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-03-30 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "elizabetaguirre1970@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392203",
            "STATUS": "A",
            "NAME": "ALBAN LONDO?O IVAN GUILLERMO",
            "FEIN": "1600322281001",
            "CUSTOMER": "1519689613",
            "ADDRESS": "MANABI E1-26 PANAMERICANA NORTE EL QUINCHE",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0984164185",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-04-15 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "ferroriente2010@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392225",
            "STATUS": "A",
            "NAME": "ALVARO ALVARO DAVID ISRAEL",
            "FEIN": "1724478852001",
            "CUSTOMER": "1519246883",
            "ADDRESS": "GARCIA MORENO E2-271 PAQUISHA LLANO CHICO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0993952211",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-02-12 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "ferreteriaalvaro1@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392226",
            "STATUS": "A",
            "NAME": "ALVARO ALVARO RUTH ELIZABETH",
            "FEIN": "1725912792001",
            "CUSTOMER": "1519246892",
            "ADDRESS": "GARCIA MORENO Y NOGALES LLANO CHICO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0981213960",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-02-18 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "rthalvaro@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392229",
            "STATUS": "A",
            "NAME": "AMERICAN PIPES  & INSTRUMENTS AMEPIPES CIA LTDA.",
            "FEIN": "1792043476001",
            "CUSTOMER": "1519246503",
            "ADDRESS": "FRANCISCO GARCIA N 70-74 Y S.MORENO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0995814239 / 2802375",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-09-14 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "apigerencia@puntonec.ec",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392237",
            "STATUS": "A",
            "NAME": "ANDRADE ENCALADA CARMEN ALICIA",
            "FEIN": "1000959914001",
            "CUSTOMER": "1519689553",
            "ADDRESS": "AV. ISIDRO AYORA N8283 PSJ PEDRO LONDO?O",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0987256446",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-03-16 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "aliss_andrade@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392275",
            "STATUS": "A",
            "NAME": "ARROYO CAICEDO FLOR ALBA",
            "FEIN": "1002497517001",
            "CUSTOMER": "1483782146",
            "ADDRESS": "ARTURO HINOJOSA E1-31 Y 17 DE SEPTIEMBRE - LLANO CHICO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0969028433 / 2830568 / 0969028433 / 2830568",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-02-28 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "floralba_75@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392284",
            "STATUS": "A",
            "NAME": "AYO GUAMAN SILVIA LUCIA",
            "FEIN": "1712699501001",
            "CUSTOMER": "1519689643",
            "ADDRESS": "GARCIA MORENO LT 2845 SECTOR LLANO GRANDE",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0959139322",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-05-04 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "luciaayo@outlook.es",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392310",
            "STATUS": "A",
            "NAME": "BASTIDAS CAJAS MARY ANGELINA",
            "FEIN": "1203374218001",
            "CUSTOMER": "1519690149",
            "ADDRESS": "AV 9 DE AGOSTO N1-83 AV DUCHICELA CALDERON",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0990599281",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-11-25 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "rhealuis3@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392311",
            "STATUS": "A",
            "NAME": "BASTIDAS FELIX DIEGO",
            "FEIN": "1716924939001",
            "CUSTOMER": "1519246487",
            "ADDRESS": "GARCIA MORENO N6-114 - A 50 MTS DE LA CAPILLA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0988259301 / 2120062",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "83 - Fiera 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-09-08 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "diegobastidj@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392313",
            "STATUS": "A",
            "NAME": "BASTIDAS SERRANO PRESENTACION",
            "FEIN": "1708680994001",
            "CUSTOMER": "1483782117",
            "ADDRESS": "SIMON BOLIVAR SN Y VIA OLIMPICA - LA CONCEPCION, JUNTO A RIO QUINCHE",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0989035287",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-02-18 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "prebas11@outlook.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392318",
            "STATUS": "A",
            "NAME": "BENAVIDES REVELO SILVIA PATRICIA",
            "FEIN": "400579231001",
            "CUSTOMER": "999956794",
            "ADDRESS": "OLMEDO 52069 Y JUNIN - A UNA CUADRA DEL PARQUEDE LA INDEPENDENCIA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "TULCAN",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "CARCHI",
            "TELEPHONE": "062981101",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "60-60 DAYS",
            "CREATION_DATE": "2012-06-14 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "60-60 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": null,
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392354",
            "STATUS": "A",
            "NAME": "CALALA AMAN WILSON FERNANDO",
            "FEIN": "1721476792001",
            "CUSTOMER": "1519690301",
            "ADDRESS": "PADRE LUIS VACARI S18 RUMI?AHUI",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0990234692",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2022-02-11 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "calala95@hotmail.es",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392360",
            "STATUS": "A",
            "NAME": "CALDERON NARVAEZ CRISTINA ELIZABETH",
            "FEIN": "1720695418001",
            "CUSTOMER": "1519690244",
            "ADDRESS": "CORAZON DE JESUS  OE3A LIBORIO MADERA N82-29 LT172 LC2",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0998969700",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2022-01-20 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "cristinacgreen@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392408",
            "STATUS": "A",
            "NAME": "CARVAJAL TORRES ELIAS DANIEL",
            "FEIN": "1704342284001",
            "CUSTOMER": "1519689636",
            "ADDRESS": "CARLOS MANTILLA E7-33 LT 132 PSJ 7D",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0993144634",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-04-28 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "danycet@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392439",
            "STATUS": "A",
            "NAME": "CEVALLOS RIVADENEIRA EDDY MAURICIO",
            "FEIN": "1710426725001",
            "CUSTOMER": "1483782250",
            "ADDRESS": "LIBERTAD OE 1-23 Y ASCAZUBI",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0939689381 / 0988880004 / 0939689381 / 0988880004",
            "CLASS_CODE": "250 - CONSTRUCTOR",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-06-08 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "109 - INFRAESTRUCTURA",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "crivadeneira_1@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392447",
            "STATUS": "A",
            "NAME": "CHAMORRO CRUZ VICTOR SLEYDER",
            "FEIN": "2150187330001",
            "CUSTOMER": "1519246846",
            "ADDRESS": "PIO XII N11-19 Y MIGUEL MEDINA - CALDERON",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0983023627",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-02-03 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "sleyder.chami@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392448",
            "STATUS": "A",
            "NAME": "CHAMPUTIZ TAPIA HUGO RODRIGO",
            "FEIN": "1717173940001",
            "CUSTOMER": "1519689983",
            "ADDRESS": "AV.ATAHUALPA S/N FRENTE A  IGLESIA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0996467779",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-09-17 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "hugo_rodrigo67@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392465",
            "STATUS": "A",
            "NAME": "CHIPANTASIG CHIPANTASHI LUIS FERNANDO",
            "FEIN": "1722868153001",
            "CUSTOMER": "1519689724",
            "ADDRESS": "REINO DE QUITO N5-129 LA UNION",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0989617282",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "CONTADO-CONTADO",
            "CREATION_DATE": "2021-06-11 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "CONTADO-CONTADO",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "fercho7-022@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392469",
            "STATUS": "A",
            "NAME": "CHULDE ANDRANGO ALEXANDRA XIMENA",
            "FEIN": "1717631715001",
            "CUSTOMER": "1519690175",
            "ADDRESS": "CARLOS MANTILLA LT 194 Y JOSE RAB",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0983342293",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "87 - Tigre 2",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-12-13 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "luis_aleman2000@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392492",
            "STATUS": "A",
            "NAME": "COMERCIAL CANO LASTRA COMPA?IA LIMITADA",
            "FEIN": "1791076567001",
            "CUSTOMER": "1376702633",
            "ADDRESS": "FRANCISCO DE ORELLANA NUMERO 721 y GONZALO DIAZ DE PINEDA .TUMBACO. PUEMBO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0995065736",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2016-03-04 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "germania.cano@canolastra.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392495",
            "STATUS": "A",
            "NAME": "COMERCIAL ELECTROMECANICA IMPORTADORA EXPORTADORA",
            "FEIN": "1790500039001",
            "CUSTOMER": "1519246450",
            "ADDRESS": "ANTONIO UOLLA N 27-114 Y SELVA ALEGRE",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0987295970 / 2540232",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "CONTADO-CONTADO",
            "CREATION_DATE": "2020-08-28 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "CONTADO-CONTADO",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "cemimex@cemimex.com",
            "EMAIL_ETIGRE": "ventas1cemimex@yahoo.com",
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392507",
            "STATUS": "A",
            "NAME": "COMERCIO Y CONSTRUCCION CACERES VITERI CIA. LTDA.",
            "FEIN": "1792329183001",
            "CUSTOMER": "1519689549",
            "ADDRESS": "AV.SANTA ANA S-298  SECTOR NAYON-",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0984682427",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-03-11 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "acecereslaspalmas@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392539",
            "STATUS": "A",
            "NAME": "CONSTRUCCIONES SOSTENIBLES DEL ECUADOR CONSTRUIBLE",
            "FEIN": "1792252032001",
            "CUSTOMER": "1376702156",
            "ADDRESS": "AV.REPUBLICA NRO. E1-67 Y AV. ATAHUALPA - A DOS CUADRAS DEL BANCO DEL ESTADO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "022265193 / 990618946 / 990618946 / 02 2265193",
            "CLASS_CODE": "207 - DISTRIBUIDOR_S",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2015-05-26 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "ramiro.camacho@construiblec.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392585",
            "STATUS": "A",
            "NAME": "CUASAPAZ TAPIA JOSE ERNESTO",
            "FEIN": "400821237001",
            "CUSTOMER": "1519246869",
            "ADDRESS": "GALO PLAZA OE10-47 Y IGNACIO DE VEITIMILLA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0991572568",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-02-09 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "cuasapaz.joer@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392615",
            "STATUS": "A",
            "NAME": "DIAZ JESUS MESIAS",
            "FEIN": "1702622034001",
            "CUSTOMER": "1519246805",
            "ADDRESS": "Julio Zabala s/n Sendero del Quinde",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0987304081",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "83 - Fiera 1",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-01-18 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "mesias.diaz2018@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392649",
            "STATUS": "A",
            "NAME": "DREINCO CIA. LTDA.",
            "FEIN": "1790748154001",
            "CUSTOMER": "1519246548",
            "ADDRESS": "URBANIZACION SHYRIS 2, CALLE H Y AV. MANUEL CORDOVA GALARZA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0985300580 / 2394604",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "CONTADO-CONTADO",
            "CREATION_DATE": "2020-09-23 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "CONTADO-CONTADO",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "dreincom5@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392694",
            "STATUS": "A",
            "NAME": "ENCARNACION REQUELME BLADIMIR STALIN",
            "FEIN": "1714080080001",
            "CUSTOMER": "1519690339",
            "ADDRESS": "CALLE CARAPUNGO OE6-09 Y DUCHILEMA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0993562556",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2022-02-25 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "multiservicios_enc@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392706",
            "STATUS": "A",
            "NAME": "ESTEVEZ IPIALES JENNY ELIZABETH",
            "FEIN": "1717328684001",
            "CUSTOMER": "1519246844",
            "ADDRESS": "BARRIO SAN LORENZO 2 CALLE 10 DE AGOSTO - GUYLLABAMBA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0987570081",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-02-03 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "jennyestevez@hotmail.es",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392736",
            "STATUS": "A",
            "NAME": "FERRETERIA SACANCELA E HIJOS CIA.LTDA.",
            "FEIN": "1791914872001",
            "CUSTOMER": "1519246462",
            "ADDRESS": "RIO SAN PEDRO E1-47",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0998110255 / 3806596",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-09-02 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "roberto_rs_35@yahoo.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392758",
            "STATUS": "A",
            "NAME": "FLORES MERCHAN MELFO FABIAN",
            "FEIN": "1714832472001",
            "CUSTOMER": "1519246833",
            "ADDRESS": "IO XII LOTE 1 Y MANUEL ENRIQUEZ - CALDERON",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0999512554 / 2063047",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-01-27 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "mfabianfm25@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392760",
            "STATUS": "A",
            "NAME": "FLORES OSORIO MONICA MARITZA",
            "FEIN": "1713476305001",
            "CUSTOMER": "1519690109",
            "ADDRESS": "OSWALDO GUALLASAMIN S/N Y REDONDEL DE RUTA VIVA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0998036339",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "83 - Fiera 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-10-29 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "jorgeartesanias@hotmail.es",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392761",
            "STATUS": "A",
            "NAME": "FLORES PE?A CARMEN MARIA",
            "FEIN": "1706032446001",
            "CUSTOMER": "1519246891",
            "ADDRESS": "DE LOS GUAYACANES N53-86 Y LAS VI?AS",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": null,
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-02-18 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": null,
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392785",
            "STATUS": "A",
            "NAME": "GALLARDO VITERI JULIO CESAR",
            "FEIN": "1711878445001",
            "CUSTOMER": "1519246557",
            "ADDRESS": "AV. SIMON BOLIVAR S/N -FRENTE AL PARQUE DE GUAMBRA-ATRAS DE LOS BOMBEROS-",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0983097798",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-09-25 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "vgjc1@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392793",
            "STATUS": "A",
            "NAME": "GAVILANES BUENA?O MILTON HUGO",
            "FEIN": "1801237452001",
            "CUSTOMER": "1519246815",
            "ADDRESS": "DE LAS VIOLETAS N47-270 AV ELOY ALFARO - JIPIJAPA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "2256352 / 0999706871",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-01-21 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "milgavy@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392794",
            "STATUS": "A",
            "NAME": "GAVILANEZ BERNAL HENRRY ROLANDO",
            "FEIN": "1710451293001",
            "CUSTOMER": "1519690313",
            "ADDRESS": "LIRIOS DE CARCELEN  MZ7 LT 28 - 29",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0978656803",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "84 - Fiera 2",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2022-02-16 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "hrgb03@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392815",
            "STATUS": "A",
            "NAME": "GOMEZ VARGAS BELGICA LORENA",
            "FEIN": "1721960902001",
            "CUSTOMER": "1519689576",
            "ADDRESS": "CHECA CALLE 3 DE MAYO Y PEDRO BAEZ",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0991513652",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-03-23 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "lorenah222@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392831",
            "STATUS": "A",
            "NAME": "GUALLICHICO SIMBA?A MARIA CRISTINA",
            "FEIN": "1714288451001",
            "CUSTOMER": "1519246936",
            "ADDRESS": "CALLE QUITO Y SAMUEL CARVAJAL",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0987206950",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-03-01 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "irma.guallichico@yahoo.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392850",
            "STATUS": "A",
            "NAME": "GUERRERO GUERRERO NELLY HIPATIA",
            "FEIN": "400955183001",
            "CUSTOMER": "1519689784",
            "ADDRESS": "AV. ATAHUALPA LTT244  COLLAS CALDERON",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0998480960 / 2037272",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "83 - Fiera 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-07-08 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "guerreron422@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392881",
            "STATUS": "A",
            "NAME": "HIDALGO IZQUIERDO LORENA DEL CARMEN",
            "FEIN": "1713044996001",
            "CUSTOMER": "1519246945",
            "ADDRESS": "OSWALDO GUAYASAMIN OE3-67",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0999871640",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-03-03 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "ferreterialagranja@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392920",
            "STATUS": "A",
            "NAME": "IMBA CUZCO SEGUNDO ANDRES",
            "FEIN": "1705950044001",
            "CUSTOMER": "1519246806",
            "ADDRESS": "Los Jilgueros N5-37 y Geovany Calles",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0995936725",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-01-18 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "imba19@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392944",
            "STATUS": "A",
            "NAME": "INLAGO REINOSO FERNANDO",
            "FEIN": "1710859834001",
            "CUSTOMER": "1519246628",
            "ADDRESS": "FRENTE A LOS TANQUES DE NESTLE VIA CAYAMBE TABACUNDO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "967750675    / 22365310",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "CONTADO-CONTADO",
            "CREATION_DATE": "2020-10-16 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "CONTADO-CONTADO",
            "SALESREP_CHANNEL": "110 - RIEGO",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "socioriego2021@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392968",
            "STATUS": "A",
            "NAME": "JACOME PORRAS ROCIO DEL PILAR",
            "FEIN": "1707562896001",
            "CUSTOMER": "1519689886",
            "ADDRESS": "ISIDRO AYORA N82-132 ANTON VAZQUES",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0983103921",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "83 - Fiera 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-08-05 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "ferrelubyj@yahoo.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392969",
            "STATUS": "A",
            "NAME": "JACOME ZAPATA ELVIA PATRICIA",
            "FEIN": "501879944001",
            "CUSTOMER": "1519246898",
            "ADDRESS": "CARAPUNGO OE9-481 GARCIA MORENO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0990397722",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-02-19 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "ferreteria.vj@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1392982",
            "STATUS": "A",
            "NAME": "JARRIN MOCHA CRISTINA YOLANDA",
            "FEIN": "1715167878001",
            "CUSTOMER": "1483782083",
            "ADDRESS": "AV.CAP.GIOVANNI CALLES LAZCANO E3-27 Y PASAJE E3J - JUNTO A LA VULCANIZADORA MARIANA DE JESUS",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0996465431 / 2035311",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "CONTADO-CONTADO",
            "CREATION_DATE": "2020-02-05 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "CONTADO-CONTADO",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "ferreteriadistribuidoraeconomica@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393093",
            "STATUS": "A",
            "NAME": "LLAGSHA MIRANDA FRANKLIN GEOVANNY",
            "FEIN": "1727036418001",
            "CUSTOMER": "1519689907",
            "ADDRESS": "PEDRO BAEZ Y 3 DE MAYO CHECA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0995202238",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "83 - Fiera 1",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-08-18 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "ferreteriasuamigofyj@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393105",
            "STATUS": "A",
            "NAME": "LOPEZ ORTIZ MARCO VINICIO",
            "FEIN": "400982393001",
            "CUSTOMER": "1519246917",
            "ADDRESS": "Galo Plaza Lasso Oe11-17 y Jaime Roldos Aguilera",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0983283118",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-02-23 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "c_coferla@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393152",
            "STATUS": "A",
            "NAME": "MANGUIA SIGCHA TERESA DE JESUS",
            "FEIN": "1707732457001",
            "CUSTOMER": "1519689711",
            "ADDRESS": "24 DE JUNIO S/N Y SAN ISIDRO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0998592264",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-06-04 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "teresamanguia@yahoo.es",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393155",
            "STATUS": "A",
            "NAME": "MANRIQUE SARANGO CRISTIAN PATRICIO",
            "FEIN": "1722501069001",
            "CUSTOMER": "1519689606",
            "ADDRESS": "SAN JUAN DE CALDERON, JUAN DE SALINAS OE6-291 Y VILLALOBOS",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0987314542",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-04-14 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "cr.manrique@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393205",
            "STATUS": "A",
            "NAME": "MEGAFERRACONS S.A.",
            "FEIN": "1792837944001",
            "CUSTOMER": "1519689831",
            "ADDRESS": "JAVIER ESPINOZA N155 Y AV. SIMON BOLIVAR",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0999464275",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "CONTADO-CONTADO",
            "CREATION_DATE": "2021-07-21 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "CONTADO-CONTADO",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "contabilidad@mfc.com.ec",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393223",
            "STATUS": "A",
            "NAME": "MERCHAN ROMERO LUIS FROILAN",
            "FEIN": "1704729944001",
            "CUSTOMER": "1519246742",
            "ADDRESS": "ISIDRO AYORA N84-156 Y JAIME ROLDOS",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0996952640 / 2803168",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "83 - Fiera 1",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-12-16 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "encofradosdongato@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393237",
            "STATUS": "A",
            "NAME": "MINTA REMACHE DANIEL FERNANDO",
            "FEIN": "604205674001",
            "CUSTOMER": "1483782087",
            "ADDRESS": "PIO XII LOTE 20 Y JESUS DEL GRAN PODER - A 3 CUADRAS DE LA IGLESIA DE SAN JUAN",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0968835205 / 3470935",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-02-06 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "provecons2@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393244",
            "STATUS": "A",
            "NAME": "MOLINA CRUZ BLANCA IGNACIA",
            "FEIN": "1704579372001",
            "CUSTOMER": "1519246918",
            "ADDRESS": "ELOY ALFARO N14-70 Y DE LAS VI?AS SECTOR CARAPUNGO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": null,
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-02-23 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": null,
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393267",
            "STATUS": "A",
            "NAME": "MOREIRA MOREIRA JOSE AURELIO",
            "FEIN": "1721542833001",
            "CUSTOMER": "1519246795",
            "ADDRESS": "LEONIDAS PLAZA N16-313 Y FRANCISCO ROBLES - CALDERON (CARAPUNGO)",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "2421228 / 0984385711",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-01-13 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "vabus1991@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393269",
            "STATUS": "A",
            "NAME": "MOREIRA VELEZ JOSE AURELIO",
            "FEIN": "1303474942001",
            "CUSTOMER": "1519246797",
            "ADDRESS": "JOSE ANDRADE N15-413 LOTE 192",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0995274730",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-01-14 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "aureliomoreira4h@outlook.es",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393283",
            "STATUS": "A",
            "NAME": "MOYON SAMANIEGO MARIA LOURDES",
            "FEIN": "1715742159001",
            "CUSTOMER": "1519246556",
            "ADDRESS": "VIA SANTA ROSA SN /PANAMERICANA SN Y EL GAVILAN",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0983828455",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "83 - Fiera 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-09-25 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": null,
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393288",
            "STATUS": "A",
            "NAME": "MURILLO CALDERON ANGEL MANUEL",
            "FEIN": "1707844401001",
            "CUSTOMER": "1483782075",
            "ADDRESS": "FRANCISCO ALBORNOZ LOTE 2 Y LAS INDUSTRIAS",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0989 095 532 / 022 036 480 / 0989 095 532 / 022 036 480",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-01-31 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "angelmurillo16@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393299",
            "STATUS": "A",
            "NAME": "NAVARRETE VERGARA ANDRES FERNANDO",
            "FEIN": "1721328001001",
            "CUSTOMER": "1519690356",
            "ADDRESS": "URB. SOLIDARIDAD GENARIOS MZ 4 LT9",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0988711670",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "CONTADO-CONTADO",
            "CREATION_DATE": "2022-03-08 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "CONTADO-CONTADO",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "mayranicolaldeherrera@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393303",
            "STATUS": "A",
            "NAME": "NEPPAS TOAPANTA JUAN FERNANDO",
            "FEIN": "1720579562001",
            "CUSTOMER": "1519246674",
            "ADDRESS": "FRANCISCO ROBLES OE1-191 Y JAIME ROLDOS AGUILERA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0998008597 / 022424588",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-11-16 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "eriflores1@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393316",
            "STATUS": "A",
            "NAME": "NU?ES MANOSALVAS JESSICA PAOLA",
            "FEIN": "1718835398001",
            "CUSTOMER": "1519246559",
            "ADDRESS": "PANAMERICANA S/N Y SAN PABLO-  A 500 MTROS DEL RESTAURANTE PAPA CUY",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0991696737 / 2778-289",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-09-25 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "compras@distribuidoraelvergel.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393317",
            "STATUS": "A",
            "NAME": "NU?EZ SUAREZ GALO ROLANDO",
            "FEIN": "1716364490001",
            "CUSTOMER": "1519246809",
            "ADDRESS": "ENTRADA A PUEMBO S/N AV.INTEROCIANICA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0984659581",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-01-20 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "galonunez@yahoo.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393326",
            "STATUS": "A",
            "NAME": "OLIVO JARAMILLO KIMBERLY NICOLE",
            "FEIN": "1717733222001",
            "CUSTOMER": "1519246704",
            "ADDRESS": "CAECELEN, JAIME ROLDOS OE3-318 Y JOSE JIMENEZ",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0983463352",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-12-04 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "richart_jaramillo100@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393383",
            "STATUS": "A",
            "NAME": "PARRALES CABRERA JORGE ARTURO",
            "FEIN": "700990161001",
            "CUSTOMER": "1519689539",
            "ADDRESS": "RIO CHANCHAN OE11-343 AV.PADRE LUIS VACARI",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0999810587",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-03-09 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": null,
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393408",
            "STATUS": "A",
            "NAME": "PERUGACHI SALCEDO HECTOR PATRICIO",
            "FEIN": "1717648164001",
            "CUSTOMER": "1519246920",
            "ADDRESS": "AV. SIMON BOLIVAR 826 SECTOR GUYLLABAMBA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0995656203",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-02-23 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "rossycristi@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393419",
            "STATUS": "A",
            "NAME": "PINTADO CALVA LEYMER LEODAN",
            "FEIN": "1103853485001",
            "CUSTOMER": "1483782059",
            "ADDRESS": "AV. CARLOS MANTILLA E4-240 Y PSJE. LAS ACACIAS - A UNA CUADRA DEL COLEGIO LAS MONJAS",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "098 131 9552",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "CONTADO-CONTADO",
            "CREATION_DATE": "2020-01-28 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "CONTADO-CONTADO",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "ferronoval@outlook.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393430",
            "STATUS": "A",
            "NAME": "PONCE MONTOYA JOSE FERNANDO",
            "FEIN": "1105025082001",
            "CUSTOMER": "1519689816",
            "ADDRESS": "OSE JIMENEZ N82-225 JOSE ORDO?EZ CORAZON DE JESUS CARCELEN",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0988504858",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-07-15 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "fponce_arq@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393435",
            "STATUS": "A",
            "NAME": "PRADO GARZON LUIS ALBERTO",
            "FEIN": "1719716902001",
            "CUSTOMER": "1519689692",
            "ADDRESS": "LOS PINOS E7-62 Y INES DE MEDINA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0994459296",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "CONTADO-CONTADO",
            "CREATION_DATE": "2021-05-28 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "CONTADO-CONTADO",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "distribuidorapradog@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393453",
            "STATUS": "A",
            "NAME": "PUGA SANCHEZ ROBERTO PAOLO",
            "FEIN": "1712719788001",
            "CUSTOMER": "1483782089",
            "ADDRESS": "PANAMERICANA NORTE LTE 221 Y CALLE B - ANTES DE ESTACION OYACOTO Y PEAJE OYACOTO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0997182677 / 2450130",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-02-06 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "robertucoo@yahoo.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393459",
            "STATUS": "A",
            "NAME": "QUESPAZ QUELAL CRISTINA ISOLINA",
            "FEIN": "1718131004001",
            "CUSTOMER": "1519246635",
            "ADDRESS": "N91B E12-74 Y E12",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0998318283",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "CONTADO-CONTADO",
            "CREATION_DATE": "2020-10-20 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "CONTADO-CONTADO",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "cristinaquespaz@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393460",
            "STATUS": "A",
            "NAME": "QUILUMBA CHUSHIG JORGE ANIBAL",
            "FEIN": "1716071236001",
            "CUSTOMER": "1519689701",
            "ADDRESS": "ATAHUALPA 101 Y PROGRESO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0990319305",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-06-03 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "jorgea3030@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393461",
            "STATUS": "A",
            "NAME": "QUILUMBAQUIN CUASCOTA DANIEL",
            "FEIN": "1706656509001",
            "CUSTOMER": "1483782088",
            "ADDRESS": "OYACOTO 4 DE OCTUBRE 34 Y 3 - AV. PRINCIPAL OYACOTO PEAJE",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0998419933 / 2839217",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "CONTADO-CONTADO",
            "CREATION_DATE": "2020-02-06 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "CONTADO-CONTADO",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "dquilumbaquinacabados@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393466",
            "STATUS": "A",
            "NAME": "QUINATOA GUALLO MONICA ALEXANDRA",
            "FEIN": "1717314536001",
            "CUSTOMER": "1519246894",
            "ADDRESS": "CACELEN BAJO E10-118 CALLE N91",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0960751813",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-02-19 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "monyaleqg@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393474",
            "STATUS": "A",
            "NAME": "QUISPE CURICHO LUIS OSWALDO",
            "FEIN": "1718178419001",
            "CUSTOMER": "1519246602",
            "ADDRESS": "LEOPOLDO CHAVEZ S/N Y CALLE OE4B",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0939289739",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-10-12 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "hidroaguaecuador@yahoo.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393477",
            "STATUS": "A",
            "NAME": "QUIZHPI CHAFLA LUIS PATRICIO",
            "FEIN": "603105081001",
            "CUSTOMER": "1519689887",
            "ADDRESS": "CALLE OE4F LT 6 Y CALLE ASTURIAS",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0985492313",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "83 - Fiera 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-08-06 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "patoquizhpi1@hotmail.com.es",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393498",
            "STATUS": "A",
            "NAME": "REINA CAMPA?A JHENY ALEXANDRA",
            "FEIN": "1002526133001",
            "CUSTOMER": "1519246794",
            "ADDRESS": "CHARIHUAYRAZO Y GALO PLAZA LASSO - CALDERON (CARAPUNGO)",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0993017515",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-01-13 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "alexandra100reina@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393524",
            "STATUS": "A",
            "NAME": "RIVERA AULESTIA MERCEDES GRIMANESA",
            "FEIN": "502101884001",
            "CUSTOMER": "1519690305",
            "ADDRESS": "PANAMERICANA NORTE LT3140B SECUNDARIA - GUYLLABAMBA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0997802122",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2022-02-15 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "distribuidor_ferreterofalcon@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393542",
            "STATUS": "A",
            "NAME": "RODRIGUEZ CASTILLO GILBER ALIPIO",
            "FEIN": "1708027105001",
            "CUSTOMER": "1483782085",
            "ADDRESS": "FRANCISCO ALBORNOZ LOTE 3 Y PIO XII - A MEDIA CUADRA DE LA SEDE SOCIAL DE TRANSPORTES SAN JUAN",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0987256486 / 3470079",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-02-05 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "gilber0001@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393568",
            "STATUS": "A",
            "NAME": "SACARIAS QUILCA NELLY ROCIO",
            "FEIN": "1714002472001",
            "CUSTOMER": "1519689579",
            "ADDRESS": "24 DE JUNIO LT 2 COLINAS DEL SOL SECTOR SAN JUAN DE CALDERON",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0983058825",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-03-24 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "rouss.nelly@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393593",
            "STATUS": "A",
            "NAME": "SANTILLAN ZAMBRANO DAVID GUILLERMO",
            "FEIN": "1715615983001",
            "CUSTOMER": "1519689672",
            "ADDRESS": "NEPTALY GODOY N14-212 CAYAMBE",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0969056618",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-05-21 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "dsantillan615@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393600",
            "STATUS": "A",
            "NAME": "SARMIENTO ORTIZ EDISON FABRICIO",
            "FEIN": "1002175121001",
            "CUSTOMER": "1519690321",
            "ADDRESS": "CARLOS MANTILLA Y JOSE ANDRADE - CARAPUNGO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0992936120",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2022-02-17 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "sanjoseferretero@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393615",
            "STATUS": "A",
            "NAME": "SEMANATE PEREZ LIZETH ESTEFANIA",
            "FEIN": "1724054323001",
            "CUSTOMER": "1483782084",
            "ADDRESS": "OYACOTO 4 DE OCTUBRE S7-41 Y Y SIN NOMBRE",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0987666369",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-02-05 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "semanate2@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393636",
            "STATUS": "A",
            "NAME": "SIGCHA MU?OZ JOSE VICENTE",
            "FEIN": "1717360216001",
            "CUSTOMER": "1483782038",
            "ADDRESS": "N6H N14-165 Y 18 - A UNA CUADRA DEL GRAN AKI CARAPUNGO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "099 4310616",
            "CLASS_CODE": "27 - HARDWARE STORE",
            "CODE_CATEGORY": "80 - Garra 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-01-22 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "vicentesigcho1982@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1393645",
            "STATUS": "A",
            "NAME": "SIMBA RECALDE CARMEN ALICIA",
            "FEIN": "1001771128001",
            "CUSTOMER": "1519689929",
            "ADDRESS": "VIA LA ESPERANZA 320 JT AL ESTADIO LA ESPERANZA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0960507508",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "83 - Fiera 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-08-27 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "simbacarmen2018@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1394114",
            "STATUS": "A",
            "NAME": "TAMAYO ERAZO DIEGO ROLANDO",
            "FEIN": "1720029295001",
            "CUSTOMER": "1519246463",
            "ADDRESS": "CESAR MORA N2-33 A UNA CUADRA DEL PUESTO DE POLICIA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0994133990 / 2390085",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "86 - Tigre 1",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-09-03 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "diego-tomayo@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1394156",
            "STATUS": "A",
            "NAME": "TITUA?A VASQUEZ GINA MARICELA",
            "FEIN": "1725948978001",
            "CUSTOMER": "1519246814",
            "ADDRESS": "PEDRO BRUNNING OE1-58 Y 19 DE DICIEMBRE - NAYON",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0983443364 / 24760252",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": null,
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-01-21 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "ginatitua?a@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": null,
            "SALES_TERRITORY": null,
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1394157",
            "STATUS": "A",
            "NAME": "TOAPANTA CASA SEGUNDO MELCHOR",
            "FEIN": "502789050001",
            "CUSTOMER": "1519689638",
            "ADDRESS": "DE LOS NARDOS, POR LA ENTRADA A LA CANCHA DE PINSHA",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0981366836",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-04-29 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "electromecaniks_@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1394161",
            "STATUS": "A",
            "NAME": "TOBAR MORA VICKY JOSETTE",
            "FEIN": "1716389000001",
            "CUSTOMER": "1519246625",
            "ADDRESS": "24 DE SEPTIEMBRE S2-37",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0958886239",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-10-15 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "vickyjosette@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1394170",
            "STATUS": "A",
            "NAME": "TORRES PERUGACHI MARIA DEL CARMEN",
            "FEIN": "1710754670001",
            "CUSTOMER": "1519689556",
            "ADDRESS": "DE LOS ARRIEROS E4-17 Y JARIBUES \"SABALA\"",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0999465072",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "007-07 DAYS",
            "CREATION_DATE": "2021-03-18 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "007-07 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "mtorresp70@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1394171",
            "STATUS": "A",
            "NAME": "TORRES VACA LUIS ASTERIO",
            "FEIN": "1704322716001",
            "CUSTOMER": "999867588",
            "ADDRESS": "MACHALA N4-385 Y GUAYAS - CALDERON",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0993998841",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2010-03-31 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "yolytorres4@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1394203",
            "STATUS": "A",
            "NAME": "VALENZUELA TERAN MONICA PATRICIA",
            "FEIN": "1711977916001",
            "CUSTOMER": "1519246693",
            "ADDRESS": "POMASQUI, URBANIZACION LAS PAMPAS, CALLE LAS GRADENIAS S/N",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0962697676",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "CONTADO-CONTADO",
            "CREATION_DATE": "2020-11-27 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "CONTADO-CONTADO",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "papeleriadetodito01@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1394218",
            "STATUS": "A",
            "NAME": "VASQUEZ PILATU?A OSCAR EDUARDO",
            "FEIN": "1755000021001",
            "CUSTOMER": "1519246455",
            "ADDRESS": "PANAMERICANA NORTE LOTE 2 -A 50 MTROS DEL HOSTAL CALDERON",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0960542658 / 22020780",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2020-08-30 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "centroferritodo@gmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        },
        {
            "0": false,
            "ID": "1394278",
            "STATUS": "A",
            "NAME": "YANEZ BARRAGAN CARLOS MAURICIO",
            "FEIN": "1710207356001",
            "CUSTOMER": "1519246850",
            "ADDRESS": "PARQUR COMERCIAL SAN MATEO LOCAL 5 - TABACUNDO",
            "QUARTER": null,
            "POSTAL_CODE": "0",
            "CITY": "QUITO",
            "STATE": null,
            "COUNTRY": "EC",
            "LOCATION": "PICHINCHA",
            "TELEPHONE": "0994999055",
            "CLASS_CODE": "246 - HARDWARE SHOP",
            "CODE_CATEGORY": "43 - EC Publico",
            "SALE_CHANNEL": "108 - PREDIAL",
            "BUSINESS_TYPE": null,
            "SHIP": "1",
            "BILL": "1",
            "CUSTOMER_TERMS": "030-30 DAYS",
            "CREATION_DATE": "2021-02-03 00:00:00",
            "PROFILE_CLASS": "CLIENTES_ECUADOR",
            "CLASSIFICATION": null,
            "PRICE_LIST": null,
            "COLLECTOR": "Cobrador Default",
            "CONTACT": null,
            "CONTRIBUTOR_CLASS": null,
            "TERMS_NAME": null,
            "SITE_TERMS_NAME": "030-30 DAYS",
            "SALESREP_CHANNEL": "108 - PREDIAL",
            "SALES_MANAGER": null,
            "EMAIL_CUSTOMER": "maelenasalazar@hotmail.com",
            "EMAIL_ETIGRE": null,
            "CUSTOMER_GROUP": null,
            "TERRITORY": "EC-Oficina Quito",
            "SALES_TERRITORY": "EC.040.REV.1000",
            "ORDER_TYPE": null,
            "EMAIL_ORDER_ACK": null,
            "SALESREP": "4009 - AC JR Predial UIO Norte",
            "STATUS_ORDER": null,
            "DATAHORA": "1646943411",
            "USUARIO": "mouts.bruno",
            "UNIDADE_PAIS": "EC",
            "MIGRATION_ID": null
        }
    ],
    "enderecos": {
        "999867588": [
            {
                "0": false,
                "ADDRESS": "MACHALA N4-385 Y GUAYAS - CALDERON",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "999956794": [
            {
                "0": false,
                "ADDRESS": "OLMEDO 52069 Y JUNIN - A UNA CUADRA DEL PARQUEDE LA INDEPENDENCIA",
                "LOCATION": "CARCHI",
                "CITY": "TULCAN",
                "STATE": null
            }
        ],
        "1376702156": [
            {
                "0": false,
                "ADDRESS": "AV.REPUBLICA NRO. E1-67 Y AV. ATAHUALPA - A DOS CUADRAS DEL BANCO DEL ESTADO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1376702633": [
            {
                "0": false,
                "ADDRESS": "FRANCISCO DE ORELLANA NUMERO 721 y GONZALO DIAZ DE PINEDA .TUMBACO. PUEMBO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1376703931": [
            {
                "0": false,
                "ADDRESS": "EL VERGEL VIA EL QUINCHE E1-488Y SAN PABLO - JUNTO AL COMPLEJO TURISTICO EL VERGEL",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1483782038": [
            {
                "0": false,
                "ADDRESS": "N6H N14-165 Y 18 - A UNA CUADRA DEL GRAN AKI CARAPUNGO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1483782059": [
            {
                "0": false,
                "ADDRESS": "AV. CARLOS MANTILLA E4-240 Y PSJE. LAS ACACIAS - A UNA CUADRA DEL COLEGIO LAS MONJAS",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1483782075": [
            {
                "0": false,
                "ADDRESS": "FRANCISCO ALBORNOZ LOTE 2 Y LAS INDUSTRIAS",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1483782083": [
            {
                "0": false,
                "ADDRESS": "AV.CAP.GIOVANNI CALLES LAZCANO E3-27 Y PASAJE E3J - JUNTO A LA VULCANIZADORA MARIANA DE JESUS",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1483782084": [
            {
                "0": false,
                "ADDRESS": "OYACOTO 4 DE OCTUBRE S7-41 Y Y SIN NOMBRE",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1483782085": [
            {
                "0": false,
                "ADDRESS": "FRANCISCO ALBORNOZ LOTE 3 Y PIO XII - A MEDIA CUADRA DE LA SEDE SOCIAL DE TRANSPORTES SAN JUAN",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1483782087": [
            {
                "0": false,
                "ADDRESS": "PIO XII LOTE 20 Y JESUS DEL GRAN PODER - A 3 CUADRAS DE LA IGLESIA DE SAN JUAN",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1483782088": [
            {
                "0": false,
                "ADDRESS": "OYACOTO 4 DE OCTUBRE 34 Y 3 - AV. PRINCIPAL OYACOTO PEAJE",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1483782089": [
            {
                "0": false,
                "ADDRESS": "PANAMERICANA NORTE LTE 221 Y CALLE B - ANTES DE ESTACION OYACOTO Y PEAJE OYACOTO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1483782117": [
            {
                "0": false,
                "ADDRESS": "SIMON BOLIVAR SN Y VIA OLIMPICA - LA CONCEPCION, JUNTO A RIO QUINCHE",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1483782124": [
            {
                "0": false,
                "ADDRESS": "AV. SIMON BOLIVAR 386 Y SN - BARRIO SAN RAFAEL A 300 MTS DEL REDONDEL",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1483782146": [
            {
                "0": false,
                "ADDRESS": "ARTURO HINOJOSA E1-31 Y 17 DE SEPTIEMBRE - LLANO CHICO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1483782250": [
            {
                "0": false,
                "ADDRESS": "LIBERTAD OE 1-23 Y ASCAZUBI",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246450": [
            {
                "0": false,
                "ADDRESS": "ANTONIO UOLLA N 27-114 Y SELVA ALEGRE",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246455": [
            {
                "0": false,
                "ADDRESS": "PANAMERICANA NORTE LOTE 2 -A 50 MTROS DEL HOSTAL CALDERON",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246462": [
            {
                "0": false,
                "ADDRESS": "RIO SAN PEDRO E1-47",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246463": [
            {
                "0": false,
                "ADDRESS": "CESAR MORA N2-33 A UNA CUADRA DEL PUESTO DE POLICIA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246487": [
            {
                "0": false,
                "ADDRESS": "GARCIA MORENO N6-114 - A 50 MTS DE LA CAPILLA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246503": [
            {
                "0": false,
                "ADDRESS": "FRANCISCO GARCIA N 70-74 Y S.MORENO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246548": [
            {
                "0": false,
                "ADDRESS": "URBANIZACION SHYRIS 2, CALLE H Y AV. MANUEL CORDOVA GALARZA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246556": [
            {
                "0": false,
                "ADDRESS": "VIA SANTA ROSA SN /PANAMERICANA SN Y EL GAVILAN",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246557": [
            {
                "0": false,
                "ADDRESS": "AV. SIMON BOLIVAR S/N -FRENTE AL PARQUE DE GUAMBRA-ATRAS DE LOS BOMBEROS-",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246559": [
            {
                "0": false,
                "ADDRESS": "PANAMERICANA S/N Y SAN PABLO-  A 500 MTROS DEL RESTAURANTE PAPA CUY",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246602": [
            {
                "0": false,
                "ADDRESS": "LEOPOLDO CHAVEZ S/N Y CALLE OE4B",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246625": [
            {
                "0": false,
                "ADDRESS": "24 DE SEPTIEMBRE S2-37",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246628": [
            {
                "0": false,
                "ADDRESS": "FRENTE A LOS TANQUES DE NESTLE VIA CAYAMBE TABACUNDO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246635": [
            {
                "0": false,
                "ADDRESS": "N91B E12-74 Y E12",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246674": [
            {
                "0": false,
                "ADDRESS": "FRANCISCO ROBLES OE1-191 Y JAIME ROLDOS AGUILERA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246693": [
            {
                "0": false,
                "ADDRESS": "POMASQUI, URBANIZACION LAS PAMPAS, CALLE LAS GRADENIAS S/N",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246704": [
            {
                "0": false,
                "ADDRESS": "CAECELEN, JAIME ROLDOS OE3-318 Y JOSE JIMENEZ",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246742": [
            {
                "0": false,
                "ADDRESS": "ISIDRO AYORA N84-156 Y JAIME ROLDOS",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246794": [
            {
                "0": false,
                "ADDRESS": "CHARIHUAYRAZO Y GALO PLAZA LASSO - CALDERON (CARAPUNGO)",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246795": [
            {
                "0": false,
                "ADDRESS": "LEONIDAS PLAZA N16-313 Y FRANCISCO ROBLES - CALDERON (CARAPUNGO)",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246797": [
            {
                "0": false,
                "ADDRESS": "JOSE ANDRADE N15-413 LOTE 192",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246805": [
            {
                "0": false,
                "ADDRESS": "Julio Zabala s/n Sendero del Quinde",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246806": [
            {
                "0": false,
                "ADDRESS": "Los Jilgueros N5-37 y Geovany Calles",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246809": [
            {
                "0": false,
                "ADDRESS": "ENTRADA A PUEMBO S/N AV.INTEROCIANICA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246814": [
            {
                "0": false,
                "ADDRESS": "PEDRO BRUNNING OE1-58 Y 19 DE DICIEMBRE - NAYON",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246815": [
            {
                "0": false,
                "ADDRESS": "DE LAS VIOLETAS N47-270 AV ELOY ALFARO - JIPIJAPA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246833": [
            {
                "0": false,
                "ADDRESS": "IO XII LOTE 1 Y MANUEL ENRIQUEZ - CALDERON",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246844": [
            {
                "0": false,
                "ADDRESS": "BARRIO SAN LORENZO 2 CALLE 10 DE AGOSTO - GUYLLABAMBA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246846": [
            {
                "0": false,
                "ADDRESS": "PIO XII N11-19 Y MIGUEL MEDINA - CALDERON",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246850": [
            {
                "0": false,
                "ADDRESS": "PARQUR COMERCIAL SAN MATEO LOCAL 5 - TABACUNDO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246869": [
            {
                "0": false,
                "ADDRESS": "GALO PLAZA OE10-47 Y IGNACIO DE VEITIMILLA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246883": [
            {
                "0": false,
                "ADDRESS": "GARCIA MORENO E2-271 PAQUISHA LLANO CHICO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246891": [
            {
                "0": false,
                "ADDRESS": "DE LOS GUAYACANES N53-86 Y LAS VI?AS",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246892": [
            {
                "0": false,
                "ADDRESS": "GARCIA MORENO Y NOGALES LLANO CHICO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246894": [
            {
                "0": false,
                "ADDRESS": "CACELEN BAJO E10-118 CALLE N91",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246898": [
            {
                "0": false,
                "ADDRESS": "CARAPUNGO OE9-481 GARCIA MORENO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246917": [
            {
                "0": false,
                "ADDRESS": "Galo Plaza Lasso Oe11-17 y Jaime Roldos Aguilera",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246918": [
            {
                "0": false,
                "ADDRESS": "ELOY ALFARO N14-70 Y DE LAS VI?AS SECTOR CARAPUNGO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246920": [
            {
                "0": false,
                "ADDRESS": "AV. SIMON BOLIVAR 826 SECTOR GUYLLABAMBA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246936": [
            {
                "0": false,
                "ADDRESS": "CALLE QUITO Y SAMUEL CARVAJAL",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519246945": [
            {
                "0": false,
                "ADDRESS": "OSWALDO GUAYASAMIN OE3-67",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689539": [
            {
                "0": false,
                "ADDRESS": "RIO CHANCHAN OE11-343 AV.PADRE LUIS VACARI",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689549": [
            {
                "0": false,
                "ADDRESS": "AV.SANTA ANA S-298  SECTOR NAYON-",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689553": [
            {
                "0": false,
                "ADDRESS": "AV. ISIDRO AYORA N8283 PSJ PEDRO LONDO?O",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689556": [
            {
                "0": false,
                "ADDRESS": "DE LOS ARRIEROS E4-17 Y JARIBUES \"SABALA\"",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689576": [
            {
                "0": false,
                "ADDRESS": "CHECA CALLE 3 DE MAYO Y PEDRO BAEZ",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689579": [
            {
                "0": false,
                "ADDRESS": "24 DE JUNIO LT 2 COLINAS DEL SOL SECTOR SAN JUAN DE CALDERON",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689584": [
            {
                "0": false,
                "ADDRESS": "LIBORIO MADERA Y JUAN VALLAURI",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689606": [
            {
                "0": false,
                "ADDRESS": "SAN JUAN DE CALDERON, JUAN DE SALINAS OE6-291 Y VILLALOBOS",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689613": [
            {
                "0": false,
                "ADDRESS": "MANABI E1-26 PANAMERICANA NORTE EL QUINCHE",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689636": [
            {
                "0": false,
                "ADDRESS": "CARLOS MANTILLA E7-33 LT 132 PSJ 7D",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689638": [
            {
                "0": false,
                "ADDRESS": "DE LOS NARDOS, POR LA ENTRADA A LA CANCHA DE PINSHA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689643": [
            {
                "0": false,
                "ADDRESS": "GARCIA MORENO LT 2845 SECTOR LLANO GRANDE",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689672": [
            {
                "0": false,
                "ADDRESS": "NEPTALY GODOY N14-212 CAYAMBE",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689692": [
            {
                "0": false,
                "ADDRESS": "LOS PINOS E7-62 Y INES DE MEDINA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689701": [
            {
                "0": false,
                "ADDRESS": "ATAHUALPA 101 Y PROGRESO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689711": [
            {
                "0": false,
                "ADDRESS": "24 DE JUNIO S/N Y SAN ISIDRO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689724": [
            {
                "0": false,
                "ADDRESS": "REINO DE QUITO N5-129 LA UNION",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689784": [
            {
                "0": false,
                "ADDRESS": "AV. ATAHUALPA LTT244  COLLAS CALDERON",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689816": [
            {
                "0": false,
                "ADDRESS": "OSE JIMENEZ N82-225 JOSE ORDO?EZ CORAZON DE JESUS CARCELEN",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689831": [
            {
                "0": false,
                "ADDRESS": "JAVIER ESPINOZA N155 Y AV. SIMON BOLIVAR",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689886": [
            {
                "0": false,
                "ADDRESS": "ISIDRO AYORA N82-132 ANTON VAZQUES",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689887": [
            {
                "0": false,
                "ADDRESS": "CALLE OE4F LT 6 Y CALLE ASTURIAS",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689907": [
            {
                "0": false,
                "ADDRESS": "PEDRO BAEZ Y 3 DE MAYO CHECA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689929": [
            {
                "0": false,
                "ADDRESS": "VIA LA ESPERANZA 320 JT AL ESTADIO LA ESPERANZA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519689983": [
            {
                "0": false,
                "ADDRESS": "AV.ATAHUALPA S/N FRENTE A  IGLESIA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519690109": [
            {
                "0": false,
                "ADDRESS": "OSWALDO GUALLASAMIN S/N Y REDONDEL DE RUTA VIVA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519690149": [
            {
                "0": false,
                "ADDRESS": "AV 9 DE AGOSTO N1-83 AV DUCHICELA CALDERON",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519690175": [
            {
                "0": false,
                "ADDRESS": "CARLOS MANTILLA LT 194 Y JOSE RAB",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519690244": [
            {
                "0": false,
                "ADDRESS": "CORAZON DE JESUS  OE3A LIBORIO MADERA N82-29 LT172 LC2",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519690301": [
            {
                "0": false,
                "ADDRESS": "PADRE LUIS VACARI S18 RUMI?AHUI",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519690305": [
            {
                "0": false,
                "ADDRESS": "PANAMERICANA NORTE LT3140B SECUNDARIA - GUYLLABAMBA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519690313": [
            {
                "0": false,
                "ADDRESS": "LIRIOS DE CARCELEN  MZ7 LT 28 - 29",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519690321": [
            {
                "0": false,
                "ADDRESS": "CARLOS MANTILLA Y JOSE ANDRADE - CARAPUNGO",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519690339": [
            {
                "0": false,
                "ADDRESS": "CALLE CARAPUNGO OE6-09 Y DUCHILEMA",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ],
        "1519690356": [
            {
                "0": false,
                "ADDRESS": "URB. SOLIDARIDAD GENARIOS MZ 4 LT9",
                "LOCATION": "PICHINCHA",
                "CITY": "QUITO",
                "STATE": null
            }
        ]
    },
    "linhas_orcamentarias": [
        {
            "ID": 0,
            "LINE": "itens"
        },
        {
            "ID": 1
        }
    ]
}